<template>
  <div id="dashboard" class="">
    <div class="container">
      <div class="row pt-5">
        <div class="col-6 pb-0">
          <img
            class="img-fluid"
            src="../assets/imgs/comparte/espacio-logo.png"
            alt="Comparte tu magia"
          />
        </div>

        <div class="col-6 text-right ">
          <img
            @click="toggleTransaccion"
            class="btncomparte pointer animate__animated animate__tada animate__infinite animate__slower"
            src="../assets/imgs/comparte/btn-subir.png"
            alt="Comparte tu magia"
          />
        </div>

        <div class="col-lg-12 text-right mt-5">
          <div class="row">
            <div
              v-for="(arte, index) in artes"
              :key="index"
              class="col-lg-4 col-6 pb-4"
            >
              <div class="bg-white" v-if="arte.imagen != null">
                <img
                  @click="
                    mostrarImagen(
                      'https://compartetumagia.pautacreativa.com.mx/api/publicaciones/' +
                        arte.imagen
                    )
                  "
                  class="img-fluid pointer"
                  :src="
                    'https://compartetumagia.pautacreativa.com.mx/api/publicaciones/' +
                    arte.imagen
                  "
                  alt="Comparte tu magia"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center py-4">
          <div>
              <img src="../assets/imgs/comparte/footer-creadores.png" alt="Espacio para creadores" class="img-fluid">
            </div>
        </div>
      </div>
    </div>

    <!-- <Footer></Footer> -->

    <!-- <div class="hidden" v-for="(img) in disponibles" :key="img">
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
        alt="flecha"
      />
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
        alt="flecha"
      />
    </div>
    <div class="hidden" v-for="(img) in dulceria" :key="img">
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
        alt="flecha"
      />
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
        alt="flecha"
      />
    </div> -->

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket ticket2 shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fM pointer blanco monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100" v-if="zoomimg != null">
          <img
            class="img-fluid preview"
            :src="zoomimg"
            alt="Comparte tu magia"
          />
        </div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <!-- <img
          class="alebrije"
          src="../assets/imgs/comparte/alebrije.svg"
          alt="Comparte tu magia"
        /> -->

        <div class="head">
          <span
            class="cerrar p-2 d-block fM pointer blanco monts"
            @click="toggleTransaccion"
            >
            <img src="../assets/imgs/comparte/btn-cerrar.png" alt="cerrar" width="24">
            </span
          >
        </div>
        <div class="body text-center w-100">
          <div class="row">
            <div class="col-12 pb-3 px-5 text-center ls3">
              <span class="fXG bold blanco">INGRESA TUS DATOS Y</span> <br />
              <span class="fXG bold blanco">COMPARTE TU MAGIA</span> <br />
            </div>

            <div
              class="col-12 text-center d-flex justify-content-center align-items-center"
            >
              <input
                type="file"
                class="hidden"
                ref="file"
                @change="fileSelected"
                accept="image/*"
              />
            </div>

            <div class="col-12 py-2">
              <div class="px-2 row">
                <form class="col-12 text-left">
                  <div class="row">
                    <div class="col-12 pb-0">
                      <div class="row"></div>
                      <label class="px-2">
                        <input
                          type="text"
                          required
                          v-model="nombre"
                          placeholder="TU NOMBRE"
                        />
                      </label>
                    </div>
                    <div class="col-12">
                      <label class="px-2">
                        <input
                          type="email"
                          required
                          v-model="email"
                          placeholder="TU EMAIL @pautacreativa.com.mx"
                          maxlength="30"
                        />
                      </label>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            

            <div class="w-100 text-center pr-lg-4">
              <div class="px-2 text-center d-inline-block align-items-center">
                <button
                  @click="$refs.file.click()"
                  class="btnaction semibold pointer d-inline-block align-items-center justify-content-center px-5 bold ls2"
                >
                  SELECCIONAR ARCHIVO
                </button>
              </div>

              <div class="py-3">
                <div id="preview"></div>
              </div>

              <!-- <div class="col-12 pb-5 px-5">
                <form action @submit.prevent>
                  
                  <label for class="py-4">
                    <span class="mb-3 fG fanta azul"
                      >Ingresa tu membresía Club Cinépolis para obtener más puntos:</span
                    >
                    
                    <input
                      type="number"
                      class="text-center"
                      v-model.trim="socio"
                      max="99999999999999999999999"
                      placeholder="Membresía Club Cinépolis "
                    />
                  </label>
                </form>
              </div> -->

              <div class="col-12 pb-5" v-if="file != null">
                <div class="px-2 text-center d-flex align-items-center">
                  <button
                    @click="tomarParticipacion()"
                    class="btnaction semibold pointer d-inline-block align-items-center justify-content-center fG ml-auto mr-auto fanta"
                  >
                    PUBLICAR
                  </button>
                </div>
              </div>
            </div>


            

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentsCollection, ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

import * as animatecss from "animate.css/animate.css";

export default {
  components: {
    // Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      zoomimg: null,
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      file2: null,
      file3: null,
      nombre: null,
      email: null,
      no_membresia_plus: "",
      cadena: "Sams",
      monto_minimo: 100,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        "merida",
        "fantasma",
        "forrest",
        "gladiador",
        "id4",
        "lalaland",
        "malefica",
        "parque-jurasico",
        "psicosis",
        "pulp",
        "et",
        "chucky",
        "diario",
        "wolverine",
        "piratas",
        "peterpan",
        "titanic",
        "lord",
        "karate",
        "silencio",
        "kill",
        "godfather",
        "resplandor",
        "mary",
        "mago",
        "blackpanther",
        "corazon",
        "inception",
        "harry",
        "simpsons",

        "aladino",
        "alicia",
        "alien",
        "ava",
        "baby",
        "batman",
        "bella",
        "ben",
        "big",
        "blancanieves",

        "buscando",
        "capitan",
        "car",
        "cenicienta",
        "coco",
        "dama",
        "dirty",
        "dracula",
        "emperor",
        "escuadron",

        "exorcista",
        "froz",
        "hombres",
        "home",
        "hunger",
        "ice",
        "increibles",
        "indiana",
        "iron",
        "it",

        "kung",
        "lilo",
        "mati",
        "matrix",
        "mega",
        "mision",
        "moa",
        "monsters",
        "mulan",
        "naufrago",

        "nosotros",
        "pesadilla",
        "picapiedra",
        "pino",
        "poca",
        "quien",
        "quinto",
        "rapsodia",
        "rata",
        "reyleon",

        "rock",
        "sabueso",
        "scooby",
        "shrek",
        "sirenita",
        "spiderman",
        "starwars",
        "super",
        "tarzan",
        "termi",

        "thor",
        "tiburon",
        "tomb",
        "top",
        "toy",
        "trans",
        "up",
        "vase",
        "villano",
        "volver",

        "wall",
        "wonder",
      ],
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      artes: [],
      overlay_transaccion: false,
      overlay_sucursal: false,
      info_monto: false,
      info_ticket: false,
      socio_plus: false,
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      tokens_disponibles: 0,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    this.getPublicaciones();
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    mostrarImagen(url) {
      this.zoomimg = url;
      this.toggleSucursal();
    },
    async getTickets2() {
      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .where("status_juego", "==", "jugando")
        .get();

      this.tickets3 = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        this.tickets3.push(ticket);

        this.tokens_disponibles += ticket.tokens_disponibles;
      });

      console.log({ tickets3: this.tickets3 });
    },

    toggleInfoMonto() {
      this.info_monto = !this.info_monto;
    },
    toggleInfoTicket() {
      this.info_ticket = !this.info_ticket;
    },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        // swal.fire(
        //   "Bien",
        //   "Recuerda conservar tus tickets de compra, da clic en jugar para participar.",
        //   "warning"
        // );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    fileSelected2: function ($event) {
      this.file2 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview2");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file2);
    },
    fileSelected3: function ($event) {
      this.file3 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview3");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file3);
    },
    async getPublicaciones() {
      var vm = this;

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.email,
        nombre: this.nombre,
      };

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "get-publicaciones.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //'Content-Type': 'multipart/form-data'
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //
              this.artes = res.datos;
            } else if (res.status == "notok") {
              //
            }
          },
          (error) => {
            // error callback
            this.enviando = false;
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      // this.file = null;
      // var preview = document.getElementById("preview");
      // preview.innerHTML = "";
    },
    async tomarParticipacion() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la imagen que deseas compartir antes de continuar...",
          "info"
        );
        return;
      }

      if (this.email == null) {
        swal.fire(
          "Oops",
          "Captura tu correo de Pauta Creativa antes de continuar...",
          "warning"
        );
        return;
      }

      if (this.nombre == null) {
        swal.fire("Oops", "Captura tu nombre antes de continuar...", "warning");
        return;
      }

      console.log("enviando");

      var vm = this;

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.email,
        nombre: this.nombre,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));
      formData.append("file", this.file);

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(process.env.VUE_APP_API_URL + "publica.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            // "Content-Type": "text/plain",
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //
              this.toggleTransaccion();

              window.location.reload();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.enviando = false;
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      // this.file = null;
      // var preview = document.getElementById("preview");
      // preview.innerHTML = "";
    },
    uploadVeryfi(ticket_obj, socio_plus) {
      const https = require("https");
      var qData = {
        img_url: ticket_obj.ticket_img_url,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "main2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            let resactualiza = await this.$store.dispatch(
              "actualizaTicketVeryfi",
              {
                ticket_ocr: res.response,
                ticket_obj: ticket_obj,
                validacion: res.validacion,
                validacion_cementos: res.validacion_cementos,
                validacion_fecha: res.validacion_fecha,
                invoice_duplicado: res.invoice_duplicado,

                //coca_sin_azucar: res.coca_sin_azucar,
                //cashi: res.cashi,
                //socio_plus: this.socio_plus,
              }
            );

            if (resactualiza === "ok") {
              this.$router.push("/dinamica");
            } else {
              swal.fire(
                "Oops",
                "El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo nuevamente, la foto debe ser nítida y contener el ticket completo no. de ticket, fecha y productos participantes.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de subir tu ticket, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .alebrije {
    width: 150px;
    position: absolute;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    top: -58px;
  }
  .ticket {
    background: #e85b21;

    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
  .ticket2 {
    margin: 0 10%;
  }
}

@media (min-width: 993px) {
  .overlayticket {
    .alebrije {
      width: 300px;
      position: absolute;
      margin: 0 auto;
      left: 50%;
      transform: translateX(-50%);
      top: -118px;
    }
  }
}
</style>
